import React from 'react';

const Icon = ({ name, className = '' }) => {
  const shared = {
    className: `icon${className ? ` ${className}` : ''}`,
    'data-icon': name,
    viewBox: '0 0 24 24',
    width: 16,
    height: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.5,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
    focusable: 'false',
  };

  switch (name) {
    case 'arrowLeft': return <svg {...shared}><path d="m15 18-6-6 6-6" /><path d="M20 12H9" /></svg>;
    case 'arrowRight': return <svg {...shared}><path d="m9 18 6-6-6-6" /><path d="M4 12h11" /></svg>;
    case 'calendar': return <svg {...shared}><rect x="3.5" y="5" width="17" height="15.5" rx="2" /><path d="M7.5 3.5v3M16.5 3.5v3M3.5 9.5h17" /></svg>;
    case 'search': return <svg {...shared}><circle cx="10.8" cy="10.8" r="6.3" /><path d="m15.5 15.5 4.2 4.2" /></svg>;
    case 'mapPin': return <svg {...shared}><path d="M19 10.2c0 5.3-7 10.3-7 10.3s-7-5-7-10.3a7 7 0 1 1 14 0Z" /><circle cx="12" cy="10" r="2.3" /></svg>;
    case 'route': return <svg {...shared}><circle cx="6" cy="18" r="2" /><circle cx="18" cy="6" r="2" /><path d="M8 18h4a3 3 0 0 0 3-3V9a3 3 0 0 1 3-3" /></svg>;
    case 'check': return <svg {...shared}><path d="m5 12.5 4.2 4.2L19 7" /></svg>;
    case 'alert': return <svg {...shared}><path d="M12 3.5 21 20H3L12 3.5Z" /><path d="M12 9v5M12 17.2v.1" /></svg>;
    case 'clock': return <svg {...shared}><circle cx="12" cy="12" r="8.5" /><path d="M12 7v5l3.5 2" /></svg>;
    case 'qrCode': return <svg {...shared}><path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2M18 18h2M14 18v2" /></svg>;
    case 'chevronLeft': return <svg {...shared}><path d="m14.5 18-6-6 6-6" /></svg>;
    case 'chevronRight': return <svg {...shared}><path d="m9.5 18 6-6-6-6" /></svg>;
    case 'externalLink': return <svg {...shared}><path d="M14 4h6v6M20 4l-9 9" /><path d="M18 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5" /></svg>;
    case 'paw': return <svg {...shared}><ellipse cx="7" cy="7" rx="1.7" ry="2.2" /><ellipse cx="12" cy="5.5" rx="1.7" ry="2.2" /><ellipse cx="17" cy="7" rx="1.7" ry="2.2" /><path d="M12 10.5c-2.4 0-5.1 2.8-5.1 5.3 0 1.6 1.1 2.6 2.8 2.6.9 0 1.6-.3 2.3-.3s1.4.3 2.3.3c1.7 0 2.8-1 2.8-2.6 0-2.5-2.7-5.3-5.1-5.3Z" /></svg>;
    default: return null;
  }
};

export default Icon;
